<template>
  <div class="ai_design">
    <el-dialog
      :visible.sync="dialogVisible"
      title="您可对已选定的AI生成图片进行全方位编辑：不仅支持文本内容修改与元素布局调整，还提供智能抠图、主体自动提取及AI内容消除等高级图像处理功能，助力高效实现精准化、专业级的视觉优化。"
      width="60%"
    >
      加载中 ... ....
    </el-dialog>
  </div>
</template>

<script>
import AIDesignSdk from "ai-design";
import {
  reqAiImageEdit,
  reqAiImageEditResult,
  saveAiImage,
} from "@/assets/api/aiProduct";
import axios from "axios";
export default {
  props: {
    imgUrl: {
      type: String,
      default: "",
    },
    productId: {
      type: String,
      default: "",
    },
    productName: {
      type: String,
      default: "",
    },
    id: {
      type: Number,
    },
  },
  data() {
    return {
      dialogVisible: false,
      AIDesign: null,
      timer: null,
    };
  },
  mounted() {},
  destroyed() {
    if (this.AIDesign) {
      this.AIDesign.close();
    }
  },
  methods: {
    async openDesign(imgurl) {
      const that = this;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      // 需要调用后端接口获取相关参数
      let res = await reqAiImageEdit({
        imageUrl: imgurl,
        productId: this.productId,
        productName: this.productName,
      });
      if (res.code == 200) {
        const taskId = res.data;
        this.timer = setInterval(async () => {
          const result = await reqAiImageEditResult({ taskId });
          if (result.code == 200) {
            const params = {
              appId: result.data.appId,
              expireTime: result.data.timestamp,
              userFlag: result.data.userFlag,
              sign: result.data.sign,
              settingCode: process.env.VUE_APP_CODE,
              designId: result.data.designId,
            };
            this.AIDesign = new AIDesignSdk(params);
            loading.close();
            this.AIDesign.open();
            window.chuangkitComplete = async function (data) {
              if (data["source-urls"] && data["source-urls"].length) {
                const blob = await that.getImageBlob(data["source-urls"][0]);
                const uploadFile = that.blobToFile(
                  blob,
                  "downloaded-image.png"
                );
                const formData = new FormData();
                formData.append("files", uploadFile);

                const uploadRes = await axios.post(
                  process.env.VUE_APP_API + "/api/common/fileInfo/newUpload",
                  formData,
                  {
                    headers: { "Content-Type": "multipart/form-data" },
                    Authorization: localStorage.getItem("token"),
                  }
                );
                if (uploadRes.data.code == 200) {
                  const saveResult = await saveAiImage({
                    aiProductResultId: that.id,
                    imageUrl: uploadRes.data.data[0].fileUrl,
                  });
                  if (saveResult.code == 200) {
                    that.$message.success(saveResult.message);
                  }
                  that.$emit("editHandlerChange", {
                    imageUrl: uploadRes.data.data[0].fileUrl,
                    aiProductResultId: that.id,
                  });
                }
              }
            };
            clearInterval(this.timer);
          }
        }, 3000);
      }
    },
    async getImageBlob(url) {
      const response = await axios.get(url, {
        responseType: "blob",
        headers: { "Cache-Control": "no-cache" },
      });
      return new Blob([response.data], {
        type: response.headers["content-type"],
      });
    },
    blobToFile(blob, filename) {
      return new File([blob], filename, {
        type: blob.type,
        lastModified: Date.now(),
      });
    },
    open(imgurl) {
      // this.dialogVisible = true;
      this.openDesign(imgurl);
    },
  },
};
</script>

<style scoped lang="scss"></style>
